
const ua = navigator.userAgent
const isAndroidApp = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1;

import { Options, Vue } from "vue-class-component";
import { getDestroyReason } from "@/api/index";
import { throttleFirstExt } from '@/assets/js/utils.js'
import { isNewBridgeView } from '@/assets/js/utils.js'
import { getClientCommonMessage, deleteAccount } from '@/utils/nativeFn'
import { registerFnHandler } from '@/utils/registerFnHandler'

@Options({
  components: {},
})
export default class Reason extends Vue {
  reasons: any = []
  isLoading: boolean = false
  reasonId: number = 0
  queryDone: boolean = false
  mounted() {
    if (isNewBridgeView()) {
      this.initNewData()
    } else {
      this.getNativeData()
      window['$eventBus'].addListener('deleteAccountResult', this.deleteAccountResult);
      window['$eventBus'].addListener('receiveAndroidMsg', this.receiveAndroidMsg);
    }
    
  }
  // 新的dsbridge初始化
  initNewData() {
    // 监听题目切换
    registerFnHandler('deleteAccountResult', (res) => {
      console.log(res, 'new deleteAccountResult')
      // let respones = res[0]? res[0]: {}
      this.deleteAccountResult(res)
    })
    this.getNewNativeData()
    let num = 0
    let timer = setInterval(() => {
      if(this.queryDone) {
        clearInterval(timer)
        return
      } else {
        this.getNewNativeData()
        num++
        if (num === 10) {
          clearInterval(timer)
          this.getDestroyReason()
        }
      }
    }, 500)
  }
  // 新端获取数据
  getNewNativeData() {
    if (this.queryDone) {
        return
    }
    getClientCommonMessage({}, (res) => {
      console.log(res,'h5调用端上getClientCommonMessage')
      res.token && localStorage.setItem('tal_token', res.token)
      res.user_id && localStorage.setItem('TAL_UID_TMP', res.user_id)
      res.services_version = localStorage.setItem('service_version', res.service_version)
      this.queryDone = true
      // 获取到端上数据之后开始调用接口
      this.getDestroyReason()
    })
  }
  // 从端上获取数据
  getNativeData() {
    window['$mobileNativeSDK'].getData((res) => {
      if (!isAndroidApp) {
        this.detailNativeData(res)
      }
    })
  }
  // 安卓监听消息
  receiveAndroidMsg(res) {
    let androidResult: any = JSON.parse(res)
    if (androidResult.event == 'getData') { // 监听获取数据返回
      this.detailNativeData(androidResult.dataJson)
    }
    if (androidResult.event == 'deleteAccountResult') { // 注销账号消息
      console.log('收到注销账号信息:', androidResult.data)
      this.deleteAccountResult(androidResult.data)
    }
  }
  // 处理端上数据
  detailNativeData(res) {
    if (localStorage.getItem('tal_token') !== res.token) {
      localStorage.setItem('tal_token', res.token)
    }
    if (res.service_version) {
      localStorage.setItem('service_version', res.service_version)
    }
    // 获取到端上数据之后开始调用接口
    this.getDestroyReason()
  }
  // 获取列表
  getDestroyReason(){
    this.isLoading = true
    getDestroyReason().then((res) => {
      this.isLoading = false
      if (res.data.code != 0) {
        return
      }
      this.reasons = res.data.data.reason_list
    }).catch((err) => {
      this.isLoading = false
    })
  }
  // 选择原因
  chooseReason(reasonId) {
    if (this.reasonId === reasonId) {
      return
    }
    this.reasonId = reasonId
  }
  // 弹出注销提示
  deleteAccountFn = throttleFirstExt(() => {
    if (!this.reasonId) return
    let data = {
      reason_id: this.reasonId
    }
    if (isNewBridgeView()) {
      console.log('调用注销账号接口1')
      deleteAccount(data, (res) => {
        console.log('调用注销账号接口', res)
      })
    } else {
      window['$mobileNativeSDK'].deleteAccount(data);
    }
  }, 1000)
  // 端上返回注销结果
  deleteAccountResult(res) {
    console.log(res, typeof res, 'deleteAccountResult')
    if (res.code != 0) {
      // @ts-ignore
      this.$router.replace({
        name: 'DestroyAccountFail'
      })
      return
    }
    // @ts-ignore
    this.$router.replace({
      name: 'DestroyAccountSuccess'
    })
  }
}
